import type { Rarity } from './constants'

export type HuntType = 'quick' | 'thorough' | 'deep'

export interface Hunt {
  type: HuntType
  label: string
  energy: number
  timeMinutes: number
  successRate: number
  weights: Record<Rarity, number>
}

export const HUNTS: Record<HuntType, Hunt> = {
  quick: {
    type: 'quick',
    label: 'Quick Hunt',
    energy: 3,
    timeMinutes: 2,
    successRate: 0.7,
    weights: {
      common: 70,
      uncommon: 22,
      rare: 8,
      'very-rare': 0,
      mythic: 0,
    },
  },
  thorough: {
    type: 'thorough',
    label: 'Thorough Hunt',
    energy: 8,
    timeMinutes: 5,
    successRate: 0.85,
    weights: {
      common: 50,
      uncommon: 30,
      rare: 20,
      'very-rare': 0,
      mythic: 0,
    },
  },
  deep: {
    type: 'deep',
    label: 'Deep Search',
    energy: 15,
    timeMinutes: 10,
    successRate: 0.95,
    weights: {
      common: 30,
      uncommon: 35,
      rare: 35,
      'very-rare': 0,
      mythic: 0,
    },
  },
}

export const HUNT_LIST = Object.values(HUNTS)
